import {AsyncStatusesEnum} from '../../../../../../libs/shared/helpers/src/types/asyncStatuses';
import {parseFileAttachment} from '../../../../../models/api/attachmentModel';
import {AppAction} from '../../../../appActions';
import {
  ContactsManagerFileState,
  ContactsManagerFileStateTypesEnum,
  fileStateIsAccountsCSVFile,
  fileStateIsContactsCsvFile,
} from './contactsManagerFileState';
import {ContactsManagerFileActionsEnum} from './contactsManagerFileStateActions';

export function contactsManagerFileReducer(
  state: ContactsManagerFileState | undefined,
  action: AppAction,
): ContactsManagerFileState | undefined {
  switch (action.type) {
    case ContactsManagerFileActionsEnum.UPLOAD_FILE:
      if (fileStateIsAccountsCSVFile(state)) {
        return {
          file: action.payload.file,
          type: action.payload.type,
          attachment: parseFileAttachment(action.payload.file),
          mapping: state.mapping,
        };
      }
      return {
        file: action.payload.file,
        type: action.payload.type,
        attachment: parseFileAttachment(action.payload.file),
      };
    case ContactsManagerFileActionsEnum.UPLOAD_COMPLETE:
      // If we are are not doing a dryrun, we can clear the file contents when the upload completes
      if (!state || !action.payload.dryRun) {
        return undefined;
      }

      return {
        ...state,
        attachment: {
          ...state.attachment,
          uploadStatus: AsyncStatusesEnum.LOADED,
        },
      };
    case ContactsManagerFileActionsEnum.UPLOAD_FAILED: {
      // Accounts csv error state
      if (
        fileStateIsAccountsCSVFile(state) &&
        action.payload.fileType === ContactsManagerFileStateTypesEnum.ACCOUNTS_CSV
      ) {
        return {
          ...state,
          errors: action.payload.errors,
          file: action.payload.errorFile ?? state.file,
          attachment: {
            ...state.attachment,
            uploadStatus: AsyncStatusesEnum.FAILED,
          },
        };
      }
      // Contacts csv error state.
      if (
        fileStateIsContactsCsvFile(state) &&
        action.payload.fileType === ContactsManagerFileStateTypesEnum.CONTACTS_CSV
      ) {
        return {
          ...state,
          errors: action.payload.errors,
          file: action.payload.errorFile ?? state.file,
          attachment: {
            ...state.attachment,
            uploadStatus: AsyncStatusesEnum.FAILED,
          },
        };
      }
      return state;
    }

    case ContactsManagerFileActionsEnum.FILE_METADATA_FETCHED: {
      if (fileStateIsAccountsCSVFile(state)) {
        return {
          ...state,
          fileMetadata: action.payload.fileMetadata,
        };
      }
      return state;
    }
    case ContactsManagerFileActionsEnum.SET_MAPPING:
      if (fileStateIsAccountsCSVFile(state)) {
        return {
          ...state,
          mapping: action.payload.mapping,
        };
      }
      return state;
    case ContactsManagerFileActionsEnum.CLEAR_FILE:
      return undefined;

    default: {
      return state;
    }
  }
}
